"use client";

import { useRouter } from "next/navigation";

import { FooterRenewal } from "@/components/molecules/renewals/footer/renewal-footer";
import { OptimizelyExperimentsEnum } from "@/config/app-constant";
import { BRAND_STAYSURE, PRODUCT, VARIANT_FLOW } from "@/constants";
import { useMemo } from "react";

type FooterRenewalCoverLevelProps = {
  footerContinueCta: string;
  onClickContinue?: () => void;
  disableMain?: boolean;
};

export default function FooterRenewalCoverLevel({
  footerContinueCta,
  onClickContinue,
  disableMain = false,
}: Readonly<FooterRenewalCoverLevelProps>) {
  const router = useRouter();
  const isAllCoverLevelVariant = useMemo(
    () =>
      typeof window !== "undefined" &&
      localStorage.getItem(
        OptimizelyExperimentsEnum.RENEWAL_DASHBOARD_ALL_COVER_LEVEL
      ) === VARIANT_FLOW &&
      PRODUCT === BRAND_STAYSURE,
    []
  );

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
      return;
    }

    if (isAllCoverLevelVariant) {
      router.push("/");
    }
    const renewalCurrentPolicyPageSkip = localStorage.getItem(
      OptimizelyExperimentsEnum.RENEWAL_CURRENT_POLICY_PAGE_SKIP
    );
    router.push(
      renewalCurrentPolicyPageSkip === VARIANT_FLOW ? "/" : "/current-policy"
    );
  };

  return (
    <FooterRenewal
      footerContinueCta={footerContinueCta}
      onClickContinue={onClickContinue}
      onClickBack={handleBack}
      disableMain={disableMain}
    />
  );
}
